module.exports = __webpack_public_path__ + "static/media/lan.8b38e962.svg";